import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule],
  templateUrl: './faq.html',
  styleUrls: ['./faq.scss']
})
export class FaqComponent implements OnInit {
  searchQuery = '';
  selectedCategory = '';

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  faqs = [
    {
      question: 'What is URL indexing?',
      answer: 'URL indexing is the process of getting search engines to discover and register your pages. Without indexing, your content cannot appear in search results regardless of how well-optimized it is. Our service accelerates this from weeks to minutes.',
      category: 'general',
      open: false
    },
    {
      question: 'How fast will my URLs get indexed?',
      answer: 'Most URLs are processed within 2 minutes of submission. The actual indexing by search engines depends on domain authority and crawl frequency, but our crawler fleet drastically accelerates the discovery process.',
      category: 'general',
      open: false
    },
    {
      question: 'What is your index success rate?',
      answer: 'We maintain a 98.5% index success rate across all submissions. URLs that fail are typically on domains with technical issues (blocked by robots.txt, returning 4xx/5xx errors, or marked noindex).',
      category: 'general',
      open: false
    },
    {
      question: 'What types of URLs can I submit?',
      answer: 'You can submit any public web page URL. We support HTTP and HTTPS URLs from any domain. Private, intranet, or password-protected URLs cannot be indexed.',
      category: 'general',
      open: false
    },
    {
      question: 'How do credits work?',
      answer: 'Each unique URL submission costs 1 credit. Duplicate URLs are automatically detected and won\'t consume additional credits. Credits never expire and can be used anytime.',
      category: 'billing',
      open: false
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'We accept 200+ cryptocurrencies via NOWPayments, plus all major credit cards. No subscription is required — buy credits and use them whenever you want.',
      category: 'billing',
      open: false
    },
    {
      question: 'Do you offer refunds?',
      answer: 'Yes. If you are unsatisfied with the service, we offer a full refund on unused credits within 30 days of purchase. Contact support@quickindexingtool.com.',
      category: 'billing',
      open: false
    },
    {
      question: 'Do you offer an API for developers?',
      answer: 'Yes. We provide a full REST API with API key authentication. You can programmatically submit URLs, check status, and manage your account. Code examples are available for cURL, Python, Node.js, and PHP.',
      category: 'api',
      open: false
    },
    {
      question: 'What is Drip Mode?',
      answer: 'Drip Mode spreads your URL submissions over a configurable time window instead of submitting them all at once. This simulates organic discovery patterns and helps avoid triggering search engine spam filters.',
      category: 'technical',
      open: false
    },
    {
      question: 'Can I upload URLs in bulk?',
      answer: 'Absolutely. You can paste multiple URLs directly, or upload CSV and TXT files containing thousands of URLs. Our deduplication engine ensures you never waste credits on repeated submissions.',
      category: 'technical',
      open: false
    },
    {
      question: 'How can I track my submissions?',
      answer: 'Use the Dashboard to view all your submissions, their current status, and detailed crawl logs. The history page lets you search and filter through all past submissions.',
      category: 'technical',
      open: false
    },
    {
      question: 'Do you guarantee indexing?',
      answer: 'We guarantee submission to our crawler fleet. Final indexing depends on search engine algorithms and content quality. URLs with technical issues (404s, robots.txt blocks) will not be indexed regardless.',
      category: 'general',
      open: false
    }
  ];

  get filteredFaqs() {
    let result = this.faqs;
    if (this.selectedCategory) {
      result = result.filter(f => f.category === this.selectedCategory);
    }
    if (this.searchQuery.trim()) {
      const q = this.searchQuery.toLowerCase();
      result = result.filter(f =>
        f.question.toLowerCase().includes(q) || f.answer.toLowerCase().includes(q)
      );
    }
    return result;
  }

  toggleFaq(faq: any) {
    faq.open = !faq.open;
  }
}
